// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image-skeleton_wrapper__JABwi","u":"image-skeleton_u__w9vFx"};